import React, { useEffect, useState } from 'react'
import { Row, Col } from 'react-bootstrap';

import { Link, navigate, useNavigate } from 'react-router-dom';
import { Card, Container, Dropdown, Nav, Navbar,Button,Form, Modal  , Table } from 'react-bootstrap';
import "../Admin/AdminMaster/AdminBilling.css";
import './Master.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { Autocomplete, TextField } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import AdminHeader from '../Admin/AdminMaster/AdminHeader';
import AdminNavBar from './AdminNavBar';
import NavLogo from './NavLogo';
import { MDBDataTable } from 'mdbreact';
import {  DailyStockFindAll,  EmployeeFindAll, ExpenseAdd, ExpenseDelete, ExpenseFindall, ExpenseUpdate, ProductFindAllOrderAllotment, StockReturnAdd, StockReturnDelete, StockReturnFindall, StockReturnUpdate } from '../Admin/API/Api';

const Expense = () => {
  const selectedLanguage = sessionStorage.getItem('selectedLanguage');
    const userdata = JSON.parse(sessionStorage.getItem('userdata'));
    const branchId = userdata.branch_id;
    const Name = userdata ? userdata.branch_name : '';

  const [isEditing, setisEditing] = useState(false);
  const [data, setData] = useState([]);
 const [date, setDate] = useState(null);
 const [show, setShow] = useState(false);
 const [id, setId] = useState();
  const [amount, setamount] = useState('');
  const [account, setAccount] = useState('');
  const [detail, setDetail] = useState('');
  const [selectedOption, setSelectedOption] = useState('');
  // const [stockId, setStockId] = useState();
  const [employee_master, setEmployee_master] = useState([]);
  const [employeeId, setEmployeeId] = useState();

  const [editData, setEditData] = useState({});

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showEdit, setShowEdit] = useState(false);

  // =========== delete modal =========
 const [show1, setShow1] = useState(false);
 const handleClose1 = () => setShow1(false);

 const [itemToDelete, setItemToDelete] = useState(null);

 const handleShow1 = (item) => {
   setItemToDelete(item);
   setShow1(true);
 };  


//  =========== Edit ======
  const handleEditClose = () => {
    setShowEdit(false);
    // setStockId('');
    setamount('');
    setAccount('');
    setDetail('');
    setDate('');
    setEmployeeId('');
    setId('');
  };

  const setEditDataFun = (item) => {
    console.log("Setting isEditing to true");
    setEmployeeId(item.employee_id);
    // setStockId(item.stock_id);
    setId(item.expense_id);

    setDetail(item.expense_detail)
    setamount(item.amount);
    setAccount(item.account);
    setDate(item.date);
    setisEditing(true);
  }

  const updateDailyStock = () => {

    if ( !detail || !amount || !amount) {
      alert("Please fill in all fields");
      return;
  }
    const formData = {
      amount :amount,
      account : account,
      expense_detail:detail,
      branch_id: branchId,
    };
    console.log("update api con...",formData);
    axios
      .put(`${ExpenseUpdate}${id}`, formData)
      .then((res) => {
        console.log("update ....",res);
        if (res.data === "UPDATE") {
          
          toast.success("Data Updated Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          Getdata();
          handleEditClose();
        }
        else if(res.data === "NOTFOUND")
        toast.info("All field are compulsory..!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        // Add debugging information to identify the issue
        console.error("Error while updating Employee:", err);
        if (err.response) {
          console.error("Response data:", err.response.data);
        }
  
        toast.error("Failed to update data, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });
  };

  const savedata = (e) => {
    e.preventDefault();
  
    if (  !account || !date || !amount || !detail) {
      alert("Please fill in all fields");
      return;
  }
  const formattedDate = dayjs(date).format('DD/MM/YYYY');
    const obj ={
      amount :amount,
      expense_detail :detail,
      account :account,
      date :formattedDate,
      branch_id: branchId,

    }
    console.log("FormData",obj)
  
    axios
      .post(ExpenseAdd, obj)
      .then((res) => {
        
        if (res.data === "SAVED") {
          console.log("res.data",res.data)
          toast.success("Data Saved Successfully!", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          // Reset form fields and reload the data
          Getdata();
          setEmployeeId('');
          setDetail('');
          // setStockId('');
          setDate('');
          setId('');
          setamount('');
          setAccount('');
          setShow(false);
          // window.location.reload(); // Note: Reloading the entire page may not be the best practice, consider updating the data from the API.
        }
        else if(res.data === "ALREADYEXIST")
        toast.info("Data Already Exists ..!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      })
      .catch((err) => {
        toast.error("Failed to upload, please try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.error(err);
      });
  };


  const Getdata = () => {
 
    axios.get(`${ExpenseFindall}/${branchId}`)
      .then((res) => {
        console.log("findallllllllll", res.data);
        if (res.data !== null) {
          setData(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };


    //delete data
    const onDelete = (item) => {
        console.log("Deleting item:", item);
        axios
          .delete(`${ExpenseDelete}${item.expense_id}`)
          .then((res) => {
            console.log("Delete response:", res.data);
            if (res.data === "DELETE") {
              toast.success("Data Deleted Successfully!", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
      
              // Update the data state to remove the deleted item
              setData((currentData) => {
                return currentData.filter((dataItem) => dataItem.expense_id !== item.expense_id);
              });
            }
            handleClose1(false);
            // No need to call Getdata() if you're updating the state directly
          })
          .catch((err) => {
            console.log("Error deleting item:", err);
            toast.error("Failed to delete, please try again", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          });
      };
      
       //EmployeeData Logic
   const Employeedata = (e) => {
    axios  
      .get(`${EmployeeFindAll}/${branchId}`)
      .then((res) => {
        if (res.data !== null) {
          setEmployee_master(res.data);
        }
        setisEditing(false);
      })
      .catch((err) => {
        // alert("Failed to upload, try again");
        toast.error("Failed to upload, try again", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log(err);
      });
  };
  
  let isExpenseFetched = false
  useEffect(() => {
    if (isEditing === false) {
      if (isExpenseFetched) return
      Getdata();
      Employeedata();  
    }
    isExpenseFetched = true
  }, [isEditing]);

  const columns = [
    { label: (selectedLanguage === 'Marathi' ? 'अनु.क्र.' : 'Sr.No'), field: 'srNo', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'तारीख' : 'Date'), field: 'date', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'खाते' : 'Account'), field: 'account', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'तपशील' : 'Detail'), field: 'expense_detail', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'रक्कम' : 'Amount'), field: 'amount', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'सुधारणे' : 'Edit'), field: 'edit', sort: 'asc' },
    { label: (selectedLanguage === 'Marathi' ? 'हटवा' : 'Delete'), field: 'delete', sort: 'asc' }
  ];
  
  const rows = data.map((item,index) => ({
    srNo: index + 1,
    date: item.date,
    account: item.account,
    expense_detail: item.expense_detail,
    amount: item.amount,
    edit: (
      <button className='m-1' style={{ color: "rgb(255, 93, 0)", border: "0px", backgroundColor: "transparent" }}
        onClick={() => setEditDataFun(item)}
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </button>
    ),
    delete: (
      <button className='m-1' style={{ color: "red", border: "0px", backgroundColor: "transparent" }}
        onClick={() => handleShow1(item)}
      >
        <i className="fa-solid fa-trash"></i>
      </button>
    )
  }));
  

  return (
    <div>
    <AdminNavBar />
       <section className="home-section">

       <NavLogo />

    <Row className="m-0 p-0 pt-5 px-md-4 px-2">
        <Col className=' rounded text-center pt-2'
          style={{
            display: "flex",
            justifyContent: "start",
            backgroundColor:"white",
            border:"0px",
            alignItems: "center",
            alignContent:"center",
            color: " rgb(47, 79, 79)",
          }}
        >
          <h5>
           {selectedLanguage === 'Marathi' ? 'खर्च' : 'Expense'}
          </h5>
        </Col>
      </Row>


{/* ========================== Return Stock =========================== */}

<Row className="m-0  py-3 px-2 mx-md-3   rounded">
    <Col className="m-0 p-0 py-2 rounded" style={{background:"white"}} >

   <Row className='m-0 p-0' style={{display:"flex",justifyContent:"space-evenly"}}>


   <Col sm={12} md={3} className='mt-2'>
  {isEditing ? (null  ) : (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        <DatePicker
          format="DD-MM-YYYY"
          label={selectedLanguage === 'Marathi' ? 'तारीख निवडा' : 'Select Date'}
          value={date}
          onChange={(newDate) => {
            console.log("date res", newDate);
            setDate(newDate);
            // Call Getdata() after setting the new date
            Getdata();
          }}
          slotProps={{ textField: { size: 'small' } }}
        />
      </DemoContainer>
    </LocalizationProvider>
  )}
</Col>

      <Col sm={12} md={3} className='mt-3'>
          <TextField
         size="small"
          id="account"
          style={{ width: "100%" }}
          label={selectedLanguage === 'Marathi' ? 'वृत्तान्त' : 'Enter account'}
          placeholder={selectedLanguage === 'Marathi' ? 'वृत्तान्त' : 'Enter account'}
          value={account}
          onChange={(e) => setAccount(e.target.value)}
        />
      </Col>



      <Col sm={12} md={3} className='mt-3'>
          <TextField
         size="small"
          id="amount"
          style={{ width: "100%" }}
          label={selectedLanguage === 'Marathi' ? 'रक्कम प्रविष्ट करा' : 'Enter amount'}
          placeholder={selectedLanguage === 'Marathi' ? 'रक्कम प्रविष्ट करा' : 'Enter amount'}
          type="number"
          value={amount}
          onChange={(e) => setamount(e.target.value)}
        />
      </Col>

      <Col sm={12} md={3} className='mt-3'>
          <TextField
           size="small"
           id="outlined-multiline-flexible"
          multiline
          maxRows={4}
          style={{ width: "100%" }}
          label={selectedLanguage === 'Marathi' ? 'खर्चाचा तपशील' : 'Expense Detail'}
          inputProps={{ maxLength: 200 }}
          placeholder={selectedLanguage === 'Marathi' ? 'खर्चाचा तपशील' : 'Expense Detail'}
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
        />
      </Col>
   </Row>


   <Row  className='m-0 p-0 mt-4 mb-3'>
   <Col style={{ display: "flex", justifyContent: "center" }}>
      {isEditing === false ? (
        <Button
          style={{
            border: "0px",
            backgroundColor:
              "rgb(47, 79, 79)",
              fontSize:"17px",
              color:"white",
            borderRadius: "15px",
          }}
          className="buttonAll py-2 px-3 mx-2 shadow "
          type="submit"
          onClick={savedata}
        >
          {selectedLanguage === 'Marathi' ? 'जतन करा' : 'Save'}
        </Button>
      ) : (
        <div>
        <Button
          style={{
            border: "0px",
            backgroundColor: "rgb(47, 79, 79)",
            borderRadius: "15px",
          }}
          className="buttonAll py-2 px-3 mx-2 shadow text-light"  
          onClick={updateDailyStock}
        >
          {selectedLanguage === 'Marathi' ? 'अपडेट करा' : 'Update'}
        </Button>
        </div>
        
      )}
    </Col>
      </Row>
    </Col>
      </Row>



     <Row className="m-0 pt-1 px-2 mx-md-3 mb-3 rounded">
      <Col className="m-0 p-0 px-3 py-3 rounded" style={{ background: "white" }}>
        <MDBDataTable
          striped
          className='custom-datatable'
          bordered
          hover
          data={{ columns, rows }}
        />
      </Col>
    </Row>
 

 {/* ============= Delete Modal ========= */}

  <Modal show={show1} onHide={handleClose1}>
      <Modal.Header style={{backgroundColor:"rgb(214, 234, 248)",color:"black"}} >
        <Modal.Title><i className="fa-solid fa-trash" style={{ color: "rgb(254, 105, 129)" }}></i>{selectedLanguage === 'Marathi' ? 'पुष्टीकरण हटवा' : 'Delete Confirmation'}</Modal.Title>
      </Modal.Header>
      <Modal.Body >{selectedLanguage === 'Marathi' ? 'तुमची खात्री आहे की तुम्ही हा आयटम हटवू इच्छिता?' : 'Are you sure you want to delete this item?'}</Modal.Body>
        <p className='text-end'>
        <Button className='mx-2' style={{color:"black",backgroundColor:"white",border:"2px solid darkslategray",borderRadius:"15px"}}  onClick={handleClose1}>
        {selectedLanguage === 'Marathi' ? 'रद्द करा' : 'Cancel'} 
        </Button>
        <Button  style={{border:"1px solid darkslategray",backgroundColor:"darkslategray" ,borderRadius:"15px"}} className='py-2 px-3 mx-2  shadow text-light' onClick={() => onDelete(itemToDelete)}>
        {selectedLanguage === 'Marathi' ? 'हटवा' : ' Delete'} 
        </Button></p>
    </Modal>









      </section>
    </div>
  )
}

export default Expense
 
